import { render, staticRenderFns } from "./paginatedSelect.vue?vue&type=template&id=2bd5dc40&"
import script from "./paginatedSelect.vue?vue&type=script&lang=js&"
export * from "./paginatedSelect.vue?vue&type=script&lang=js&"
import style0 from "./paginatedSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports